import { apiClient as api } from "./httpClient";

// Calendário de feriados da entidade (RN-407): nacionais vêm do seed do produto
// (seeded=true, imutáveis exceto ativar/inativar); estaduais/municipais/personalizados
// são cadastrados pela clínica. O on-date alimenta o aviso no modal de agendamento.

export type HolidayScope = "national" | "state" | "municipal" | "custom";

export interface HolidayRow {
  id: string;
  /** yyyy-MM-dd (sem hora — nunca converter com new Date(iso), desloca fuso) */
  day: string;
  holidayTitle: string;
  scope: HolidayScope;
  seeded: boolean;
  active: boolean;
}

export interface SaveHolidayPayload {
  day: string;
  holidayTitle: string;
  scope: HolidayScope;
}

export const holidaysService = {
  getByEntity: async (entityId: string, includeInactive = true): Promise<HolidayRow[]> => {
    const response = await api.get(`/holidays/by-entity/${entityId}?includeInactive=${includeInactive}`);
    return response.data;
  },

  /** Feriados ativos na data (yyyy-MM-dd) — aviso do agendamento. */
  getOnDate: async (entityId: string, date: string): Promise<HolidayRow[]> => {
    const response = await api.get(`/holidays/on-date/${entityId}?date=${date}`);
    return response.data;
  },

  create: async (entityId: string, payload: SaveHolidayPayload): Promise<void> => {
    await api.post("/holidays", { entityId, ...payload });
  },

  update: async (id: string, payload: SaveHolidayPayload): Promise<void> => {
    await api.put(`/holidays/${id}`, payload);
  },

  setActive: async (id: string, active: boolean): Promise<void> => {
    await api.patch(`/holidays/${id}/active`, { active });
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/holidays/${id}`);
  },
};
